// Typelizer digest 56b7c6194f57c4330fa703d4e5b9de7b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/ledger/issues/:issue_id/resolution */
  create: (
    params: { issueId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/issues/:issue_id/resolution', params, options),
    method: 'post',
  }),
}
